import { TileButton } from '@/components/buttons/tile/component';
import { ContentPanel } from '@/components/content-panel';
import { usePossibleRoutes } from '@/hooks';
import { useCurrentUserQuery } from '@/hooks/use-current-user/graphql.generated';
import { Flex, Grid, Text, Title } from '@mantine/core';
import { IconBuildingCommunity, IconBuildingFactory, IconRecycle } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { motion } from 'motion/react';
import styles from './styles.module.css';

const AnimateTile = ({ children }: { children: React.ReactNode }) => {
	return (
		<motion.div
			initial={{ opacity: 0, y: 100 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.5 }}
		>
			{children}
		</motion.div>
	);
};

export const SelectContextPage = () => {
	const { data } = useCurrentUserQuery({ skip: true });
	const navigate = useNavigate();
	const { possibleRoutes } = usePossibleRoutes();

	return (
		<Flex className={styles.content}>
			<ContentPanel>
				<Title order={1}>{`Hi ${data?.currentUser?.contact?.firstName ?? 'there!'}`}</Title>
				<Text>Please select your context</Text>
				<Grid pt="lg" w="100%">
					{possibleRoutes.includes('facility') && (
						<Grid.Col span={6}>
							<AnimateTile>
								<TileButton
									icon={IconBuildingFactory}
									text="Facilities App"
									onClick={() => navigate({ to: '/facility/home' })}
								/>
							</AnimateTile>
						</Grid.Col>
					)}
					{possibleRoutes.includes('user') && (
						<Grid.Col span={6}>
							<AnimateTile>
								<TileButton
									icon={IconRecycle}
									text="User App"
									onClick={() => navigate({ to: '/home' })}
								/>
							</AnimateTile>
						</Grid.Col>
					)}
					{possibleRoutes.includes('council') && (
						<Grid.Col span={6}>
							<AnimateTile>
								<TileButton
									icon={IconBuildingCommunity}
									text="Council App"
									onClick={() => navigate({ to: '/council' })}
								/>
							</AnimateTile>
						</Grid.Col>
					)}
				</Grid>
			</ContentPanel>
		</Flex>
	);
};
